<template>
    <section v-if="options.storesicons > 0">
      <b-container>
        <div class="ml-3 mr-3">
            <p class="text-uppercase text-muted mhdr">{{$lang('apps')}}</p>
            <a href="https://apps.apple.com/us/app/ipg-user-portal/id1663490884">
                <img class="store-link" alt="Apple Store" src="/dist/badge-astore.png" height="42px">
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.ipgphotonics.up">
                <img class="store-link" alt="Google Play" src="/dist/badge-gplay.png" height="42px" >
            </a>
        </div>
      </b-container>
    </section>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: mapState(['options']),
  data() {
    return {
    };
  },
  locales: {
        en: {
          apps: "Applications",
          },
        de: {
          apps: "Apps",
          },
        ru: {
          apps: "Приложения", 
        },
        pl: {
          apps: "Aplikacje",
        }
      }
}
</script>
<style scoped>
.mhdr{
    font-size: 12px;
}
.store-link{
    margin-right: 1rem;
}
</style>




// WEBPACK FOOTER //
// src/MobileStores.vue